import { useMutation, useQuery } from '@tanstack/react-query';
import { api, primeCsrf } from './api';
import type { CredentialData, CredentialRevealedData } from '@/types/api';

/** Portal vault: list saved credentials (no secret) and reveal on demand. */
export function usePortalCredentials() {
  return useQuery({
    queryKey: ['portal-credentials'],
    queryFn: async (): Promise<CredentialData[]> => {
      const { data } = await api.get<CredentialData[]>('/v1/portal/credentials');
      return data;
    },
  });
}

export function useRevealCredential() {
  return useMutation({
    mutationFn: async (id: number): Promise<CredentialRevealedData> => {
      await primeCsrf();
      const { data } = await api.post<CredentialRevealedData>(`/v1/portal/credentials/${id}/reveal`);
      return data;
    },
  });
}
